//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular from 'angular';

import template from './social-menu.html';

import { FeatureNames } from '@bvengineering/curalate-features';
import { dashboardStatesByName as states } from '../../top-level-states';

angular.module('curalate').component('socialMenu', {
  template,
  controller: [
    'SessionVarsService',
    function (SessionVarsService) {
      this.$onInit = () => {
        this.isFacebookReview = SessionVarsService.isFacebookReview();
      };
    },
  ],
});
